<template>
  <page class="profileView">
    <div>
      <h4>{{$t('profile.view.updateForm')}}</h4>
      <profile-form />
    </div>
    <div>
      <h4>{{$t('profile.view.newPasswordForm')}}</h4>
      <new-password-form />
    </div>
  </page>
</template>

<script>
import ProfileForm from "@/components/profile/ProfileForm"
import NewPasswordForm from "@/components/profile/NewPasswordForm"

export default {
  name: "Profile",
  components: {
    ProfileForm,
    NewPasswordForm
  }
}
</script>

<style lang="scss" scoped>
$c: '.profileView';

#{$c} {
  .pageComponent {
    &:nth-child(2) {
      margin-top: 24px;
    }
  }
}
</style>